import { Heading, Stack } from '@chakra-ui/react';
import { useTranslations } from 'use-intl';

import { AdminCompaniesList } from './AdminCompaniesList';

type Props = unknown;

/**
 * AdminCompanies.
 * Dashboard of the admin user.
 *
 * @returns {JSX.Element}
 */
export function AdminCompanies(): JSX.Element {
  const i18nAdminList = useTranslations('AdminList.Companies');

  return (
    <Stack spacing="6">
      <Heading>{i18nAdminList('Title')}</Heading>
      <AdminCompaniesList />
    </Stack>
  );
}

export type AdminCompaniesProps = Props;
